export const setToken = (state, action) => {
    return {...state, token: action.payload}
}

export const set = (state, action) => {
    return {...state, user: action.payload}
}